export default __webpack_public_path__ + "static/media/timeicon.1efa5fbf.svg";